module.exports = __webpack_public_path__ + "img/mbBanner7.79562462.png";